module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5c81be8fab4f5ed793554698938ff7f8.gif";